import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Photo from './components/photo.vue';
import PhotoUpload from './components/photo-header.vue';
import BatchUpload from '@blade/common/components/batch-uploader.vue';
let default_1 = class extends Vue {
};
default_1 = __decorate([
    Component({
        name: 'StaffPhoto',
        components: { Photo, PhotoUpload, BatchUpload },
    })
], default_1);
export default default_1;
